__turbopack_context__.v({
  "fullLayer": "navigation-logo-module__CruOza__fullLayer",
  "fullLayerCollapsed": "navigation-logo-module__CruOza__fullLayerCollapsed",
  "link": "navigation-logo-module__CruOza__link",
  "linkCollapsed": "navigation-logo-module__CruOza__linkCollapsed",
  "logoImage": "navigation-logo-module__CruOza__logoImage",
  "logoStage": "navigation-logo-module__CruOza__logoStage",
  "logoStageCollapsed": "navigation-logo-module__CruOza__logoStageCollapsed",
});
